<template>
  <div class="c_content_grid" :data-theme="theme">
    <div class="c_wrapper_2022">
      <div class="c_content_grid__show_all">
        <h3 v-if="data.title" v-html="data.title"></h3>
        <div class="c_content_grid__masonry_container">
          <div class="c_content_grid__masonry">
            <Button unstyle reset :href="content.itemEntry[0].url" v-for="(content, index) in data.gridItems" :key="index">
              <div class="c_content_grid__content">
                <h4 v-if="content.itemTitle || content.itemEntry[0].title">{{ content.itemTitle || content.itemEntry[0].title }}</h4>
                <span v-if="content.itemDescription">{{ content.itemDescription }}</span>
              </div>
              <MediaImage
                :sources="content.itemImage.length > 0 ? [content.itemImage?.[0]?.image] : [content.itemEntry?.[0].featuredImage?.[0]?.image]"
                v-if="content.itemImage[0]?.image || content.itemEntry?.[0].featuredImage?.[0]?.image"
                :alt="content.itemTitle || content.itemEntry[0].title"
                background
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import Button from 'Components/button/Button.vue';
import IconSVG from 'Components/icon_svg/IconSVG.vue';
import ImageContentGridSlider from './ImageContentGridSlider.vue';
import MediaImage from 'Components/image/MediaImage.vue';
import Overlay from 'Components/overlay/Overlay.vue';

export default defineComponent({
  name: 'ContentGrid',
  components: {
    Button,
    IconSVG,
    ImageContentGridSlider,
    MediaImage,
    Overlay,
  },
  props: {
    data: { type: Object, default: () => {} },
  },
  setup(props) {
    const theme = props.data?.theme || 'darkMode';
    const content_grid_ref = ref(null);

    return { theme, content_grid_ref };
  },
});
</script>

<style lang="scss">
.c_content_grid {
  --content-grid-bg: var(--color-black);
  --content-grid-color: var(--color-white);
  --content-grid-link-color: var(--color-yellow);
  &[data-theme='darkMode'] {
    --content-grid-bg: var(--color-black);
    --content-grid-color: var(--color-white);
    --content-grid-link-color: var(--color-yellow);
  }
  &[data-theme='lightMode'] {
    --content-grid-bg: var(--color-white);
    --content-grid-color: var(--color-black);
    --content-grid-link-color: var(--color-red);
  }
  background-color: var(--content-grid-bg);
  color: var(--content-grid-color);
  padding: px_to_rem(24) 0;
  @include mq($mq_sm_to_md) {
    padding: px_to_rem(80) 0;
  }
  h3 {
    @include fs_lh(32, 40, 32, 40);
    @include font('graphik_semibold');
    margin-bottom: px_to_rem(14);
    text-align: center;
    @include mq($mq_sm_to_md) {
      margin-bottom: px_to_rem(48);
    }
  }
  &__masonry_container {
    display: flex;
    justify-content: center;
  }
  &__masonry {
    display: flex;
    flex-wrap: wrap;
    max-width: 1150px;
    gap: px_to_rem(12);
    width: 100%;
    a {
      box-sizing: border-box;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-content: center;
      min-width: 220px;
      min-height: 320px;
      max-height: 500px;
      background: var(--content-grid-bg);
      flex: 1 0 auto;
      overflow: hidden;
      color: var(--color-white);
      text-decoration: none;
      &:hover {
        .c_content_grid__content {
          background-color: var(--color-yellow);
          color: var(--color-black);
        }
      }
      .c_image_bg {
        position: absolute;
        inset: 0;
        height: 100%;
        width: 100%;
      }
    }
    @for $i from 1 through 36 {
      a:nth-child(#{$i}) {
        $h: (random(320) + 70) + px;
        width: $h;
      }
    }
    @media (max-width: 700px) {
      a {
        max-width: 100%;
      }
    }
    @media (min-width: 700px) {
      a {
        max-width: 600px;
      }
    }
  }
  &__content {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.85);
    transition: all ease-in-out 0.15s;
    padding: px_to_rem(20) px_to_rem(10);
    text-align: center;
    h4 {
      @include font('graphik_bold');
      @include fs_lh(18, 28, 18, 28);
    }
  }
}
</style>
